import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";

/** Who is signed in. Every page that needs an account asks this first; the
 *  answer is cached so moving between pages does not ask again. */
export function useMe() {
  return useQuery({ queryKey: ["me"], queryFn: api.me, staleTime: 5 * 60_000 });
}
